module.exports = __webpack_public_path__ + "static/media/nuts.b355574c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/nuts.svg
// module id = 1126
// module chunks = 0